import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CommonAPIService } from '../commonAPI.service';
import { Partner } from '../../shared/models/partner.model';

@Injectable({
  providedIn: 'root',
})
export class PartnerService extends CommonAPIService {
  getPartner(partnerId: string): Observable<Partner> {
    return this.get<Partner>(`v3/partner/${partnerId}?format=lite`);
  }

  updatePartner(partner: Partial<Partner>, partnerId: string): Observable<Partner> {
    return this.put<Partner>('v3/partner/' + partnerId + '?format=lite&sourceSystemKey=PRO', partner);
  }

  createPartner(partner: any): Observable<any> {
    return this.post('v3/partner?format=lite&sourceSystemKey=PRO', partner);
  }
}
